module.exports = __webpack_public_path__ + "img/tz.d0d714c3.png";